/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { TableSearchInput } from "~/components/SearchInput";
import { useQueryState } from "~/hooks/useQueryState/useQueryState";
import { ReportsQuery } from "~/views/resources_v2/types";

export function ReportsSearch() {
  const { queryState, updateQueryState } = useQueryState<ReportsQuery>();

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <TableSearchInput<ReportsQuery>
      onSubmit={handlePhraseField}
      placeholder={"Type a Keyword, e.g. Report Name, User Email, etc."}
      disabled
    />
  );
}
